import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IObraNomenclaturesRequest } from 'Data/interfaces/Obra/IObraNomenclaturas';

export const useQueryUpdateNomenclatureObra = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IObraNomenclaturesRequest) => {
      return ObrasApiV2.updateNomenclatures(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({
          queryKey: [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        }),
      ]);

      const applyNomenclatureUpdate = (obra: IObraResponse): IObraResponse => ({
        ...obra,
        VersionConfig: {
          ...obra.VersionConfig,
          HasRevisionControl: data.data.HasRevisionControl,
          VersionFields: data.data.VersionFields,
          Tenant: data.data.Tenant,
        },
        VersionConfigFk: data.data.IsVersionControlDefault
          ? undefined
          : data.data.VersionConfigId,
      });

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (oldData) => {
        return oldData?.map((obra) => {
          if (obra.ConstructionSiteId === variables.constructionStieId) {
            return applyNomenclatureUpdate(obra);
          }
          return obra;
        });
      });
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        (oldData) => {
          if (oldData && oldData.ConstructionSiteId === variables.constructionStieId) {
            return applyNomenclatureUpdate(oldData);
          }
          return oldData;
        },
      );

      toastHandler.showSuccess('Nomenclatura da Obra atualizada com sucesso!');
    },
    onError: (error: any) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao atualizar Nomenclatura!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    updateNomenclatureObra: mutate,
    isLoading: isPending,
  };
};
